module.exports = __webpack_public_path__ + "static/media/c.a4374897.svg";